/** Type Facteur d'influence spécifique aux fonctions Evolution et Benchmarking */
class Factor {
    Id: string = "";
    Operator: string = "/";
    AutoFilter : boolean = true;
    InWarning : boolean = false;
    Label: string;
    // ObjectTypes : string[];
    // Allocations: string[];
    
    constructor(id: string) {
        this.Id = id;
    }

    public static Create(factorId: string, feature: string): Factor {
        let type = require ("./Factor/" + feature + "/Factor");
        return new type.default(factorId);
    }
}

export default Factor;